export default __webpack_public_path__ + "static/media/encourage.65b6e6e1.mp3";